import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./common.css";
import fallbackLogo from "assets/images/logos/logo.jpeg";

const Navbar = () => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();

  const handleImageError = (e) => {
    e.target.onerror = null;
    if (e.target.src !== fallbackLogo) {
      e.target.src = fallbackLogo;
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar navbar-expand-lg custom-navbar sticky-top">
      <div className="container-fluid px-3 px-lg-5">

        {/* Logo + Party Name */}
        <Link className="navbar-brand d-flex align-items-center gap-3" to="/">
          <div className="logo-wrapper">
            <img
              src="https://i.pinimg.com/originals/87/98/06/879806e54afb6170f276e63787dc10e6.jpg?nii=t"
              alt="BJP Logo"
              className="nav-logo"
              onError={handleImageError}
            />
          </div>
          <div className="brand-titles">
            <span className="party-name d-block">भारतीय जनता पक्ष</span>
            <span className="party-subname d-block">नागरिक सेवा portal</span>
          </div>
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler shadow-none border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu Items */}
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">

            <li className="nav-item">
              <Link className={`nav-link ${isActive("/") ? "active-link" : ""}`} to="/">
                मुख्यपृष्ठ
              </Link>
            </li>

            <li className="nav-item">
              <Link className={`nav-link ${isActive("/about_us") ? "active-link" : ""}`} to="/about_us">
                आमच्याबद्दल
              </Link>
            </li>

            <li className="nav-item">
              <Link className={`nav-link ${isActive("/schemes") ? "active-link" : ""}`} to="/schemes">
                योजना
              </Link>
            </li>

            <li className="nav-item">
              <Link className={`nav-link ${isActive("/complaint") ? "active-link" : ""}`} to="/complaint">
                तक्रारी नोंदवा
              </Link>
            </li>

            {/* <li className="nav-item">
              <Link className={`nav-link ${isActive("/suggestions") ? "active-link" : ""}`} to="/suggestions">
                सुझाव द्या
              </Link>
            </li> */}

            <li className="nav-item">
              <Link className={`nav-link ${isActive("/gallery") ? "active-link" : ""}`} to="/gallery">
                गॅलरी
              </Link>
            </li>

            {/* Login / Profile Button */}
            <li className="nav-item dropdown ms-lg-3 mt-3 mt-lg-0">
              {!token ? (
                <Link to="/login" className="profile-btn d-inline-flex align-items-center justify-content-center gap-2">
                  <i className="bi bi-box-arrow-in-right"></i>
                  <span>लॉगिन</span>
                </Link>
              ) : (
                <>
                  <a
                    href="/#"
                    className="profile-btn dropdown-toggle d-inline-flex align-items-center gap-2"
                    id="profileDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={(e) => e.preventDefault()}
                  >
                    <span className="user-avatar-badge">{user?.full_name?.charAt(0) || "U"}</span>
                    <span>{user?.full_name?.split(" ")[0] || "प्रोफाइल"}</span>
                  </a>

                  <ul
                    className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3 mt-2"
                    aria-labelledby="profileDropdown"
                  >
                    <li>
                      <Link className="dropdown-item py-2" to="/profile">
                        👤 माझे प्रोफाइल
                      </Link>
                    </li>

                    <li>
                      <Link className="dropdown-item py-2" to="/all_user_complaints">
                        📋 माझ्या तक्रारी
                      </Link>
                    </li>

                    <li><hr className="dropdown-divider my-1" /></li>

                    <li>
                      <button
                        className="dropdown-item py-2 text-danger font-semibold"
                        onClick={() => {
                          localStorage.removeItem("token");
                          localStorage.removeItem("user");
                          localStorage.removeItem("permissions");
                          localStorage.removeItem("role");
                          navigate("/");
                        }}
                      >
                        🚪 लॉगआउट
                      </button>
                    </li>
                  </ul>
                </>
              )}
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
